import 'intl-pluralrules';
import i18n from 'i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { initReactI18next } from 'react-i18next';
import translationEN from './src/assets/locales/en/translation.json';

// English ships with the app; every other language is a separate chunk that
// loads only when it is selected (or was selected on a previous visit).
const languageLoaders = {
  bg: () => import('./src/assets/locales/bg/translation.json'),
  gj: () => import('./src/assets/locales/gj/translation.json'),
  hn: () => import('./src/assets/locales/hn/translation.json'),
  kn: () => import('./src/assets/locales/kn/translation.json'),
  mh: () => import('./src/assets/locales/mh/translation.json'),
  tg: () => import('./src/assets/locales/tg/translation.json'),
  tm: () => import('./src/assets/locales/tm/translation.json'),
  ml: () => import('./src/assets/locales/ml/translation.json'),
};

export async function loadLanguage(language) {
  const loader = languageLoaders[language];
  if (!loader || i18n.hasResourceBundle(language, 'translation')) return;
  const translations = await loader();
  i18n.addResourceBundle(
    language,
    'translation',
    translations.default || translations
  );
}

const STORE_LANGUAGE_KEY = 'lang';
const languageDetector = {
  type: 'languageDetector',
  async: true,
  init: () => {},
  detect: async function (callback) {
    try {
      await AsyncStorage.getItem(STORE_LANGUAGE_KEY).then((language) => {
        if (language) {
          return loadLanguage(language)
            .catch(() => {})
            .then(() => callback(language));
        } else {
          return callback('en');
        }
      });
    } catch (error) {}
  },
  cacheUserLanguage: async function (language) {
    try {
      await AsyncStorage.setItem(STORE_LANGUAGE_KEY, language);
    } catch (error) {}
  },
};

const fallbackLng = ['en'];
const availableLanguages = [
  'bg',
  'en',
  'gj',
  'hn',
  'kn',
  'mh',
  'tg',
  'tm',
  'ml',
];

const resources = {
  en: {
    translation: translationEN,
  },
};

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    resources,
    fallbackLng,
    detection: {
      checkWhitelist: true,
    },
    debug: false,
    whitelist: availableLanguages,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
